import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog.tsx';
import { Button } from '@/components/ui/button.tsx';
import { Label } from '@/components/ui/label.tsx';
import FunnelPageSelector from './FunnelPageSelector.tsx';
import type { Funnel } from '@/types/funnel.ts';

interface DuplicateFunnelModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    funnel: Funnel | null;
    onSubmit: (pageIds: number[]) => void;
    isLoading: boolean;
}

export default function DuplicateFunnelModal({ open, onOpenChange, funnel, onSubmit, isLoading }: DuplicateFunnelModalProps) {
    const [pageIds, setPageIds] = useState<number[]>([]);

    useEffect(() => {
        if (open) setPageIds([]);
    }, [open]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSubmit(pageIds);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>Duplicar Funil</DialogTitle>
                </DialogHeader>
                <form onSubmit={handleSubmit} className="space-y-5 pt-2">
                    <p className="text-sm text-gray-500">
                        Duplicando <strong>{funnel?.nome}</strong>. Selecione as páginas para o novo funil:
                    </p>

                    <div className="space-y-2">
                        <Label className="text-sm font-medium">Páginas do Facebook *</Label>
                        <FunnelPageSelector selectedIds={pageIds} onChange={setPageIds} />
                    </div>

                    <div className="flex gap-2 pt-2 border-t">
                        <Button type="button" variant="outline" className="flex-1" onClick={() => onOpenChange(false)} disabled={isLoading}>
                            Cancelar
                        </Button>
                        <Button type="submit" className="flex-1" disabled={isLoading || pageIds.length === 0}>
                            {isLoading ? 'Duplicando...' : `Duplicar para ${pageIds.length || '–'} página(s)`}
                        </Button>
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
}
